import { ERROR_STRING } from '@/config/constants';
import { ContractType } from '@/gql/graphql';

export function formatContractType(type: string | null | undefined): string {
  if (!type) {
    return '';
  }

  switch (type) {
    case ContractType.Custom:
    case ContractType.Online:
      return 'Онлайн';

    case ContractType.Offline:
      return 'Оффлайн';
  }

  console.warn(`Unknown contract type: "${type}"`);
  return ERROR_STRING;
}
